"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Alarm = _interopRequireDefault(require("../model/Alarm"));

var _ApiError = _interopRequireDefault(require("./ApiError"));

var _Env = require("../util/Env");

var AlarmApi =
/*#__PURE__*/
function () {
  function AlarmApi(dom, storage, events) {
    (0, _classCallCheck2.default)(this, AlarmApi);
    this.dom = dom;
    this.storage = storage;
    this.events = events;
  }

  (0, _createClass2.default)(AlarmApi, [{
    key: "getAlarms",
    value: function getAlarms(appName, callback) {
      var dom = this.dom,
          storage = this.storage,
          events = this.events;
      var httpRequest = this.getHttpRequest();

      if (!httpRequest) {
        throw "Could not create XMLHttpRequest. Browser may not support AJAX.";
      }

      var url = this.getUrl(appName);

      var requestHandler = function requestHandler() {
        if (httpRequest.readyState === XMLHttpRequest.DONE) {
          if (httpRequest.status === 200) {
            try {
              var result = JSON.parse(httpRequest.responseText);
              var alarms = [];

              if (Array.isArray(result)) {
                alarms = result.map(function (alarmData) {
                  return new _Alarm.default(alarmData, dom, storage, events);
                });
              }

              callback(alarms, null);
            } catch (e) {
              callback(null, new _ApiError.default(httpRequest, e));
            }

            return;
          } else {
            callback(null, new _ApiError.default(httpRequest));
          }
        }
      };

      httpRequest.onreadystatechange = requestHandler;
      httpRequest.open('GET', url);
      httpRequest.send();
      return true;
    }
    /**
     * @VisibleForTesting
     */

  }, {
    key: "getHttpRequest",
    value: function getHttpRequest() {
      return new XMLHttpRequest();
    }
  }, {
    key: "getUrl",
    value: function getUrl(appName) {
      var qa = (0, _Env.isQa)() ? 'qa' : '';
      var lang = window.I18n && window.I18n.langEnabled ? window.I18n.lang : 'en';
      var portalIdArray = /^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)/.exec(document.location.pathname);
      var maybePortalIdParam = portalIdArray && portalIdArray.length > 1 ? "?portalId=" + portalIdArray[1] + "&lang=" + lang : "?lang=" + lang;
      return "https://api.hubspot" + qa + ".com/firealarm/v2/alarm/" + appName + maybePortalIdParam;
    }
  }]);
  return AlarmApi;
}();

var _default = AlarmApi;
exports.default = _default;
module.exports = exports.default;